/**
 * Class to active custom select in Copyright Footer.
 */
export default class CopyrightFooter {
  constructor() {
    this.openCopyrightLanguage();
  }

  /*
   * Open language box
   */
  openCopyrightLanguage() {
    const selectedClass = 'c-copyrightFooter__selected';
    const selected: HTMLElement = document.querySelector(`.${selectedClass}`);
    const optionsContainer: HTMLElement = document.querySelector(
      '.c-copyrightFooter__optionsContainer'
    );
    const optionsList: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.c-copyrightFooter__option'
    );

    document.addEventListener('click', (event) => {
      if (event.target instanceof HTMLElement) {
        const currentElement: HTMLElement = event.target;

        // Add slide event
        if (
          currentElement.classList.contains(selectedClass) ||
          currentElement.closest(`.${selectedClass}`)
        ) {
          event.preventDefault();
          optionsContainer.classList.toggle('is-active');
          selected.classList.toggle('is-active');
          return;
        }
        // Close box
        optionsContainer.classList.remove('is-active');
        selected.classList.remove('is-active');
      }
    });

    optionsList.forEach((option) => {
      option.addEventListener(
        'click',
        () => {
          const linkObfuscate: HTMLElement =
            option.querySelector('.js-linkObfuscate');

          // Update current language
          selected.innerHTML = linkObfuscate.innerHTML;
          selected.classList.remove('is-active');
          optionsContainer.classList.remove('is-active');
        },
        { passive: true }
      );
    });
  }
}
